@if (edge?.currentData | async; as currentData) {
  <energymonitor-chart [currentData]="currentData"></energymonitor-chart>
}
